import { h, Component } from "preact";



import Login from "../components/Login";
import LostPwd from "../components/LostPwd";
import Token from "../components/Token";
import Maintenance from "../components/Maintenance";
import Inscription from "../components/Inscription";
import DevenirAmbassadeur from "../components/DevenirAmbassadeur";
import DevenirVendeur from "../components/DevenirVendeur";
import DevenirAcquereur from "../components/DevenirAcquereur";
import Mentored from "../components/Mentored";
import Search from "../components/Search";
import AmbassadorsMap from '../components/AmbassadorsMap'
import ConfirmedEmail from "../components/ConfirmedEmail";
import Blank from "../components/Blank";

import E404 from "../components/E404";

import ReactGA from "react-ga4";
ReactGA.initialize("G-YEDC8PZB9J");


const SwitchComponent = (props) => {
	//console.log("switchComponent", props);
	switch (props.path) {
		case "/login":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <Login {...props} />;
			break;
		case "/lostpwd":
			return <LostPwd {...props} />;
			break;
		case "/t/:id":
			return <Token id={props.id} />;
			break;
		case "/parrainage/:id":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <Mentored id={props.id} />;
			break;
		case "/maintenance":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <Maintenance />;
			break;
		case "/confirmed-email/:mode":
			return <ConfirmedEmail mode={props.mode} />;
			break;
		case "/inscription":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <Inscription />;
			break;
		case "/devenir-ambassadeur":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <DevenirAmbassadeur {...props} />;
			break;
		case "/devenir-acquereur":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <DevenirAcquereur step="0" />;
			break;
		case "/devenir-vendeur":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <DevenirVendeur step="0" />;
			break;
		case "/404":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <E404 />;
			break;
		case "/blank":
			return <Blank />;
			break;
		case "/search/:id?":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <Search {...props} />;
			break;
		case "/nos_ambassadeurs":
			ReactGA.send({ hitType: "pageview", page: props.path });
			return <AmbassadorsMap accessToken="pk.eyJ1IjoidGVsZW1ldGlzIiwiYSI6ImNrcWZvd2c0MzByM2wybnNjOGR2c2JtNGEifQ.npIdy2KCcctfSjvVWcSDXw" />;
			break;
		default:
			return <E404 />;
			break;
	}
};

export default class WithMainThemeAnonymous extends Component {

	render(props) {
		//console.log("WithMainThemeAnonymous");

		return (
			// <div>
			// 	<script async src="https://www.googletagmanager.com/gtag/js?id=G-YEDC8PZB9J"></script>
			// 	<script>
			// 		window.dataLayer = window.dataLayer || [];
			// 		function gtag(){dataLayer.push(arguments)}
			// 		gtag('js', new Date());

			// 		gtag('config', 'G-YEDC8PZB9J');
			// 	</script>
			// <div style="width: 100%; margin-top: 83px; background-color: #F0F0F0; min-height: calc(100vh - 227px );">
			// {/*//calc(100vh - 346px )*/}
			<SwitchComponent {...props} style="margin-top: 90px" />
			// </div>
			// </div>
		);
	}
}
// export default class WithMainThemeAnonymous extends Component {
// 	render(props) {
// 		return (
// 			<Fragment>
// 				<CssBaseline />
// 				<HeaderAnonyme />
// 				<div style="width: 100%; margin-top: 83px; background-color: #F0F0F0; min-height: calc(100vh - 227px );">
// 					{/*//calc(100vh - 346px )*/}
// 					<SwitchComponent {...props} style="margin-top: 90px" />
// 				</div>
// 				<Footer2 />
// 			</Fragment>
// 		);
// 	}
// }
